import UtilsSchema from "@repoflow/schema/utils";

import {
  orgId,
  entryId,
  date,
  meal,
  food,
  serving,
  calories,
  protein,
  carbs,
  fat,
  fiber,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/Entry",
    type: "object",
    properties: {
      orgId,
      entryId,
      date,
      meal,
      food,
      serving,
      calories,
      protein,
      carbs,
      fat,
      fiber,
      createdAt,
      updatedAt,
    },
  },
  {
    // `entryId` is absent: the server mints it from `date`. See ./fields.
    id: "/Public/Entry/Create",
    type: "object",
    properties: {
      date,
      meal,
      food,
      serving,
      calories,
      protein,
      carbs,
      fat,
      fiber,
    },
    // Mirrors EntryInputCreate's non-null fields exactly.
    required: ["date", "meal", "food"],
  },
  {
    // `date` is absent on purpose: it is the front of the range key, so moving
    // an entry to another day would be a second row. See ./fields.
    id: "/Public/Entry/Update",
    type: "object",
    properties: {
      meal,
      food,
      serving,
      calories,
      protein,
      carbs,
      fat,
      fiber,
    },
    required: ["meal", "food"],
  },
];
